module.exports = __webpack_public_path__ + "img/binance_logo_black_and_yellow.c01b2ec3.webp";